<ion-header>
  <ion-toolbar>
    <ion-title>Player Information</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form">
    <ion-list>
      <ion-item>
        <ion-input [label]="getPlayerNames(1)" labelPlacement="floating" type="text" formControlName="side1Note"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input [label]="getPlayerNames(2)" labelPlacement="floating" type="text" formControlName="side2Note"></ion-input>
      </ion-item>
    </ion-list>
  </form>

  <ion-button (click)="update()" expand="block">
    Update player information
  </ion-button>

</ion-content>